import PropTypes from 'prop-types';
import { useState } from 'react';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
// @mui
import { Box, List, ListItemText, Typography, Collapse } from '@mui/material';
// components
import Iconify from 'src/components/iconify/Iconify';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';
import { tokenService } from 'src/services';
import useNavConfig from 'src/layouts/dashboard/nav/config';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ ...other }) {
  const navConfig = useNavConfig();
  let data = navConfig;

  const generateCombinedPermissions = (type, frontAuthArray) => {
    if (frontAuthArray === false) {
      return `${type}:${false}`;
    } else {
      return frontAuthArray.map((frontAuth) => `${type}:${frontAuth}`);
    }
  };

  const user = tokenService.getUser();
  const type = user?.type || '';
  const frontAuthArray = user?.frontAuth || false;
  const combinedPermissions = generateCombinedPermissions(type, frontAuthArray);

  let lastCategory = '';

  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item, index) => {
          const currentCategory = item.category?.toLocaleUpperCase() || '';
          
          // Görünürlük Kontrolü
          const isVisible =
            combinedPermissions === 'superadmin:false' ||
            combinedPermissions === 'superadmin:true' ||
            item.permissions.some((permission) =>
              combinedPermissions.includes(permission)
            );

          if (!isVisible) {
            return null;
          }

          // Kategori Başlığı Kontrolü
          if (currentCategory !== lastCategory) {
            lastCategory = currentCategory;
            return (
              <div key={currentCategory + index}>
                <Typography
                  sx={{
                    color: '#B41E1E',
                    fontSize: "11px",
                    lineHeight: '13.31px',
                    fontWeight: '700',
                    marginBlock: '5px',
                    fontFamily: 'Inter, sans-serif',
                    margin: '5px',
                    marginLeft: '16px',
                  }}
                >
                  {currentCategory}
                </Typography>
                <NavItem item={item} />
              </div>
            );
          }

          return <NavItem key={index} item={item} />;
        })}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info, children } = item;
  const { pathname } = useLocation();

  const isActive = children 
    ? children.some(child => pathname === child.path)
    : pathname === path || pathname.startsWith(path);

  const [open, setOpen] = useState(isActive);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  if (children) {
    return (
      <>
        <StyledNavItem
          onClick={handleOpen}
          sx={{
            color: '#ffffff',
            listStyleType: 'none',
            '&.active': {
              bgcolor: 'rgba(255, 255, 255, 0.08)',
              fontWeight: 'fontWeightBold',
            },
          }}
          className={open ? 'active' : ''}
        >
          <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
          <ListItemText disableTypography primary={title} sx={{ fontFamily: 'Inter, sans-serif', fontSize: 14, fontWeight: 500 }} />
          {info && info}
          {/* Ok İkonu */}
          <Iconify
            icon={open ? 'eva:arrow-ios-downward-fill' : 'eva:arrow-ios-forward-fill'}
            sx={{ width: 16, height: 16, ml: 1 }}
          />
        </StyledNavItem>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {children.map((child) => {
              const isActiveChild = pathname === child.path;

              return (
                <StyledNavItem
                  key={child.title}
                  component={RouterLink}
                  to={child.path}
                  className={isActiveChild ? 'active' : ''}
                  sx={{
                    listStyleType: 'none',
                    color: '#ffffff',     
                    '&.active': {
                      color: '#DC423C',
                      bgcolor: '#ffffff',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                >
                  <StyledNavItemIcon sx={{ width: 20, height: 20 }}>
                    <Box component="span" sx={{ width: 4, height: 4, bgcolor: 'currentColor', borderRadius: '50%' }} />
                  </StyledNavItemIcon>
                  <ListItemText disableTypography primary={child.title} sx={{ fontFamily: 'Inter, sans-serif', fontSize: 13, fontWeight: 500 }} />
                </StyledNavItem>
              );
            })}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      className={isActive ? 'active' : ''}
      sx={{
        listStyleType: 'none',
        color: '#ffffff',
        '&.active': {
          color: '#DC423C',
          bgcolor: isActive ? '#ffffff' : 'inherit',
          fontWeight: isActive ? 'fontWeightBold' : 'inherit',
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
      <ListItemText disableTypography primary={title} sx={{ fontFamily: 'Inter, sans-serif', fontSize: 14, fontWeight: 500 }} />
      {info && info}
    </StyledNavItem>
  );
}